import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Video1Poster from '../../assets/06ded317b0694947.jpg';
import Video1 from '../../assets/06ded317b0694947.mp4';
import { useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H1, H2, Text1 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

// 🔸 isInView.section1 을 props로 받음
type IntroduceSection1Props = {
  isInView: boolean;
};

const IntroduceSection1 = ({ isInView }: IntroduceSection1Props) => {
  const { t } = useTranslation();
  const { horizontal: padding, top: paddingTop } = useResponsivePadding();
  const [imageAnimated, setImageAnimated] = useState(false);
  const { isMobile, isTablet } = useDeviceType();

  const isEng = ['en', 'en-mobile'].includes(i18n.language);

  useEffect(() => {
    if (isInView && !imageAnimated) {
      setImageAnimated(true);
    }
  }, [isInView, imageAnimated]);

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={paddingTop} />

      <div style={{ overflow: 'hidden', paddingBottom: '0.5rem' }}>
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 0.7 : 0.0, ease: 'easeOut', delay: isInView ? (imageAnimated ? 0.0 : 1.6) : 0.0 }} // 사라질땐 딜레이 없이 바로 적용되도록함, 딜레이 있음 스크롤 왔다갔다 빨리하면 사라져 있질 않음
        >
          {isMobile ? (
            <H1>
              We are not an utility fabrication company.
            </H1>
          ) : (
            <H2 style={{ fontSize: pxToRem(isTablet ? 68 : 62) }}>
              We are not an utility fabrication company.
            </H2>
          )}
        </motion.div>
      </div>

      <div style={{ overflow: 'hidden', paddingBottom: '0.5rem' }}>
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 0.7 : 0.0, ease: 'easeOut', delay: isInView ? (imageAnimated ? 0.3 : 1.9) : 0.0 }}
        >
          {isMobile ? (
            <H1>
              We are an AI-driven smart flow platform company.
            </H1>
          ) : (
            <H2 style={{ fontSize: pxToRem(isTablet ? 68 : 62) }}>
              <>
                We are an AI-driven smart flow platform company.
              </>
            </H2>
          )}
        </motion.div>
      </div>

      <BTBox height={isMobile ? 8 : pxToRem(43)} />

      <div style={{ overflow: 'hidden', paddingBottom: '5px' }}>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 0.7 : 0.0, ease: 'easeOut', delay: isInView ? (imageAnimated ? 0.2 : 2.2) : 0.0 }}
        >
          <Text1 style={{ opacity: 0.5 }}>
            {t('우리는 단순한 설비 설치를 넘어, 산업 환경의 본질을 재설계합니다.')}
          </Text1>
        </motion.div>
      </div>

      <div style={{ overflow: 'hidden', paddingBottom: '5px' }}>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 0.7 : 0.0, ease: 'easeOut', delay: isInView ? (imageAnimated ? 0.5 : 2.5) : 0.0 }}
        >
          <Text1 style={{ opacity: 0.5 }}>
            {t('데이터와 기술이 어우러져 만들어내는 Smart flow system을 완성합니다.')}
          </Text1>
        </motion.div>
      </div>

      <BTBox height={isMobile ? 16 : pxToRem(54)} />

      <motion.div
        initial={{ scale: 2, opacity: 1 }}
        animate={imageAnimated ? { scale: [2, 1.8, 1], opacity: 1 } : {}}
        transition={{
          duration: 1.5,
          ease: [0.65, 0, 0.35, 1],
          times: [0, 0.7, 1],
        }}
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: '2300px',
          transformOrigin: 'center bottom', // ⬅️ 여기가 핵심입니다
          aspectRatio: isMobile ? '328 / 200' : '1560 / 600', // ⬅️ 가로세로 비율 적용
          overflow: 'hidden',
        }}
      >
        <video
          src={Video1}
          autoPlay
          muted
          loop
          playsInline
          poster={Video1Poster}
          style={{
            width: '100%',
            maxWidth: '2300px',
            aspectRatio: isMobile ? '328 / 200' : '1560 / 600',
            height: 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
      </motion.div>
    </VerticalLayout>
  );
};

export default IntroduceSection1;
